import * as types from "./actionTypes";
import {toId} from "../../utils/apiUtils";

export const currentUserLogout = () => async (dispatch) => {
    dispatch({ type: types.CURRENT_USER_LOG_OUT });
}

export const loadOrUpdateCurrentUser = (userData) => async (dispatch, getState) => {
    const existing = getState().currentUser;
    if (existing) {
        dispatch({ type: types.CURRENT_USER_LOADED, payload: { ...existing, ...userData } });
    } else {
        dispatch({ type: types.CURRENT_USER_LOADED, payload: {...userData, id: toId(userData.pk), lastReads: userData.lastReads}});
    }
}